import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ModalConfirmacaoCirurgica, ConfirmacaoCirurgicaParam } from '@/types/interfaces/confirmacao-cirurgica'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import { ConfirmacaoCirurgicaStatusEnum } from '@/types/interfaces/Solicitacao'

@Module({ namespaced: true, name: 'ConfirmacaoCirurgicaStore' })
export default class ConfirmacaoCirurgicaStore extends VuexModule {
  modal: ModalConfirmacaoCirurgica = {
    confirmacaoCirurgica: false,
  }

  confirmacaoCirurgicaParamDefault: ConfirmacaoCirurgicaParam = {
    solicitacaoId: '',
    templateMapaCirurgico: {},
    confirmacaoCirurgiaMedico: null,
    confirmacaoCirurgiaPaciente: null,
    telefoneMedico: '',
    telefonePaciente: '',
  }

  confirmacaoCirurgicaParam: ConfirmacaoCirurgicaParam = { ...this.confirmacaoCirurgicaParamDefault }

  @Action
  async gerarConfirmacao(tipo: 'Medico' | 'Paciente') {
    const { solicitacaoId } = this.confirmacaoCirurgicaParam

    const response = SolicitacaoCirurgiaApi.gerarConfirmacaoCirurgica(solicitacaoId, tipo)
    return response
  }

  @Action
  async confirmar(tipo: 'Medico' | 'Paciente') {
    const { solicitacaoId } = this.confirmacaoCirurgicaParam
    const status = ConfirmacaoCirurgicaStatusEnum.confirmado

    const response = SolicitacaoCirurgiaApi.confirmacaoCirurgicaConfirmarRecusar(solicitacaoId, tipo, status)
    return response
  }

  @Action
  async recusar(tipo: 'Medico' | 'Paciente') {
    const { solicitacaoId } = this.confirmacaoCirurgicaParam
    const status = ConfirmacaoCirurgicaStatusEnum.recusado

    const response = SolicitacaoCirurgiaApi.confirmacaoCirurgicaConfirmarRecusar(solicitacaoId, tipo, status)
    return response
  }

  @Mutation
  setConfirmacaoCirurgicaParam(data: ConfirmacaoCirurgicaParam) {
    this.confirmacaoCirurgicaParam = data
  }

  @Mutation
  setShowModalConfirmacaoCirurgica(value: boolean) {
    this.modal.confirmacaoCirurgica = value
  }

  @Mutation
  reset() {
    this.confirmacaoCirurgicaParam = { ...this.confirmacaoCirurgicaParamDefault }
  }
}
